import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const ConsumablesRedux = createActions(
  {
    getStudentConsumablesRequest: ['centerId', 'studentId'],
    getStudentConsumablesSuccess: ['results'],
    getStudentConsumablesError: ['error'],
  },
  {
    prefix: 'CONSUMABLES_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = ConsumablesRedux
export const ContractsTypes = Types
export default Creators

export const INITIAL_STATE = createState({},
  {
    get: true,
  })

const getStudentConsumablesRequest = state =>
  state.merge({ get: { fetching: true, error: null } }, d)

const getStudentConsumablesSuccess = (state, { results }) =>
  state.merge({ get: { fetching: false, error: null, results } }, d)

const getStudentConsumablesError = (state, { error }) =>
  state.merge({ get: { fetching: false, error } }, d)

export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.getStudentConsumablesRequest]: getStudentConsumablesRequest,
    [Types.getStudentConsumablesSuccess]: getStudentConsumablesSuccess,
    [Types.getStudentConsumablesError]: getStudentConsumablesError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ConsumablesRedux.js